import { Field, Textarea } from '@chakra-ui/react'
import { forwardRef } from 'react'
import { FormLabel } from '../Form/FormLabel'

export const TextArea = forwardRef(
  ({ name, isInvalid, label, placeholder, onChange, value, textAlign = 'left', ...props }, ref) => {
    return (
      <Field.Root invalid={isInvalid}>
        {label && <FormLabel>{label}</FormLabel>}
        <Textarea
          ref={ref}
          id={name}
          placeholder={placeholder}
          textAlign={textAlign}
          value={value || ''}
          onChange={onChange}
          {...props}
        />
      </Field.Root>
    )
  }
)
